import { SortDestinationColorSchema } from "@redotech/redo-fulfillment-wms-common/schema/sort-destination";
import { SortDispositionSchema } from "@redotech/redo-fulfillment-wms-common/schema/sort-disposition";
import { sortDestinationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const updateSortDestination = {
  name: "updateSortDestination" as const,
  input: z.object({
    id: sortDestinationIdFormat.schema,
    name: z.string().optional(),
    disposition: SortDispositionSchema.optional(),
    color: SortDestinationColorSchema.optional(),
  }),
  output: z.null(),
};
